/**
 * 微信分享 - 极简版
 */

import { isWeiXin } from './device';

interface ShareData {
  title: string;
  desc: string;
  imgUrl: string;
}

declare global {
  interface Window {
    wx: any;
  }
}

export const setupWxShare = async (shareData: ShareData) => {
  if (!isWeiXin()) return;
  
  try {
    const response = await fetch(`https://wechat.cgtn.com/socialweb/social/weixin/getKeys.do?url=${encodeURIComponent(window.location.href.split('#')[0])}`);
    const data = await response.json();
    
    window.wx.config({
      debug: false,
      appId: 'wxd61ff47456d31b8e',
      timestamp: data.data.timestamp,
      nonceStr: data.data.nonceStr,
      signature: data.data.signature,
      jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
    });

    window.wx.ready(() => {
      const config = {
        title: shareData.title,
        desc: shareData.desc,
        link: window.location.href,
        imgUrl: shareData.imgUrl
      };
      
      window.wx.updateAppMessageShareData(config);
      window.wx.updateTimelineShareData(config);
    });
  } catch (error) {
    console.warn('微信分享配置失败:', error);
  }
};